// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","caption":"caption-1ahBc","multiCity":"multiCity-1eOYi"};